 /**
 * @license
 * Copyright 2016 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {LayerManager, MouseSelectionState, SelectedLayerState, TrackableDataSelectionState} from 'neuroglancer/layer';
import {NavigationState} from 'neuroglancer/navigation_state';
import {RenderLayerRole} from 'neuroglancer/renderlayer';
import {TrackableBoolean} from 'neuroglancer/trackable_boolean';
import {WatchableSet} from 'neuroglancer/trackable_value';
import {VisibilityPrioritySpecification} from 'neuroglancer/visibility_priority/frontend';
import {TrackableValue} from 'neuroglancer/trackable_value';
import { verifyString } from 'neuroglancer/util/json';
import { ConfigDialog } from 'neuroglancer/ui/congfig-dialog';

export {VisibilityPrioritySpecification};

export interface ViewerState extends VisibilityPrioritySpecification {
  visibleLayerRoles: WatchableSet<RenderLayerRole>;
  navigationState: NavigationState;
  mouseState: MouseSelectionState;
  showAxisLines: TrackableBoolean;
  layerManager: LayerManager;
  selectedLayer: SelectedLayerState;
  selectionDetailsState: TrackableDataSelectionState;
}

export class ConfigStorage {
  configStorage = new Map()
  parentStorage = new Map()
  activedTool = new TrackableValue<string | undefined>(undefined, verifyString);
  configDialog: ConfigDialog
  tryToSetKey: string;
  restoreConfig = new Map();
  restoreAllConfig = new Map();
  constructor() {
    // this.activedTool.changed.add(() => {
    //   const currentActivedTool = this.activedTool.value
    //   if (currentActivedTool && this.configStorage.get(currentActivedTool)) {
    //     this.configDialog = new ConfigDialog(this.parentStorage.get(currentActivedTool), this)
    //   } else {
    //     if (this.configDialog) this.configDialog.close()
    //   }
    // })
    this.restoreConfig = this.getConfig();
  }
  setActivedTool(val: string | undefined) {
    if (!val) {
      this.activedTool.value = undefined
      return
    }
    if (!this.isReady(val)) {
      this.tryToSetKey = val
      return
    }
    this.activedTool.value = val
  }
  getActivedTool(){
    return this.activedTool.value;
  }
  registConfig(key: string, parent: HTMLElement, config: any) {
    this.configStorage.set(key, config)
    this.parentStorage.set(key, parent)
  }
  getConfig(){
    return this.configStorage
  }
  registParentSingle(key: string, parent: HTMLElement) {
    this.parentStorage.set(key, parent);
    this.restoreAllConfig.set(key, parent);
    if(!this.configStorage.get(key)){
      // 注册的时候再添加
      this.configStorage.set(key, this.restoreConfig.get(key));
    }
  }
  registConfigSingle(key: string, config: any) {
    this.configStorage.set(key, config)
    if (this.isReady(key) && this.tryToSetKey === key) {
      this.activedTool.value = key
      this.tryToSetKey = ''
    }
  }
  isReady (key: string) {
    return this.parentStorage.get(key) && this.configStorage.get(key)
  }
  clear () {
    // 清空之前先存储
    this.restoreConfig = new Map();
    this.configStorage.forEach((key, value)=>{
      this.restoreConfig.set(value, key);
    });
    this.parentStorage.forEach((key, value)=>{
      this.restoreAllConfig.set(value, key);
    });
    this.configStorage.clear()
    this.parentStorage.clear()
  }
}